import * as request from '@/utils/request'
import setSign from '@/utils/sign';
import store from '@/store/index'
import {
  getSsigUrl,
  getPdkdSign
} from './helper';
import {
  JSEncrypt
} from 'jsencrypt'
let Encrypt = new JSEncrypt();
let pubKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDb7uHl1+GibL2MUUxpYJUKpVnW
SBmVv4dm6kawuRe3WTMpv9ywI+AvpGegGWDmQ7wqEf+ynJ4XS2DY3+KJ4gs31Yeg
K+U2xL7loC2n4PTnBx/6XaegQp0WpVXZ7X2+YeTmxL7T0nyJnBglSENP+ea74CKF
1NGQfYGaJoHKsx1csQIDAQAB
-----END PUBLIC KEY-----`
Encrypt.setPublicKey(pubKey);
const version = 'v1'
const rand = 'lexar'
const api = 'api'
const contentType = 'application/json;charset=UTF-8'
const method = 'POST'
let head = ''
if(['test', 'development'].includes(process.env.NODE_ENV)){
  head = 'https://apps-test.lexar.com'
} else if(process.env.NODE_ENV === 'production'){
  head = 'https://apps.lexar.com'
}

// 重构接口地址:https://yapi.lexar.com/project/95/interface/api/cat_1132
// v1接口地址:https://yapi.lexar.com/project/95/interface/api/cat_885

/**
 * @description: 获取是否需要密码
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*} https://yapi.lexar.com/project/95/interface/api/11844
 */

export const getLoginFlag = async (params = {}, options = {needShareKey: true}) => {
  const url = getSsigUrl(method, `/Share/${api}/${rand}/${version}/isLogin`, contentType)
  return await request.post(url, {}, params, options)
}

/**
 * @description: 获取分享详细信息
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */

export const getShareInfo = async (params = {}, options = {needShareKey: true}) => {
  const url =store.state.Api_Version=='v1'?getSsigUrl(method, `/Share/${api}/${rand}/${version}/shareInfo`, contentType):'/share/api/v2/shareInfo'
  return await request.post(url, {} ,params, options)
}

/**
 * @description: 输入密码登录
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const login = async (data, params = {}, options = {needShareKey: true}) => {
  const url =store.state.Api_Version=='v1'?getSsigUrl(method, `/Share/${api}/${rand}/${version}/login`, contentType):'/share/api/v2/login'
  return await request.post(url, data, params, options)
}

/**
 * @description: 获取文件列表
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
 export const getShareList = async (data, params = {}, options = {needShareKey: true}) => {
  const url =store.state.Api_Version=='v1'? getSsigUrl(method, `/Share/${api}/${rand}/${version}/list`, contentType):'/share/api/v2/list'
  return await request.post(url, data, params, options)
}


/**
 * @description: 获取图片消费地址
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const getDownloadList = async (data, params = {}, options = {needShareKey: true}) => {
  const url = getSsigUrl(method, `/Share/${api}/${rand}/${version}/downloadUrlList`, contentType)
  return await request.post(url, data, params, options)
}

/**
 * @description: 获取打包地址
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const getPackDownload = async (data, params = {}, options = {needShareKey: true}) => {
  const url = store.state.Api_Version=='v1'?getSsigUrl(method, `/Share/${api}/${rand}/${version}/pack/downloadUrl`, contentType):'/share/api/v2/pack/downloadUrl'
  return await request.post(url, data, params, options)
}
/**
 * @description: 举报
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const Report = async (data, params = {}, options = {needShareKey: true,needToken: true}) => {
  const url =  store.state.Api_Version=='v1'?`/Share/api/lexar/v1/report`: `/share/api/v2/report`
  return await request.post(url,data, params, options)
}



/**
 * @description: 获取视频转码
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const getVideoBitRate = async (data, params = {}, options = {needShareKey: true, needCredentials: false}) => {
  let url = `${head}/user/share/v1/getVideoBitRate`
  return await request.post(url, data, params, options)
}



/**============================登录===============================*/

/**
 * @description: 获取短信验证码
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const sendSMSVerifyCode = async (params = {}, options = {needCredentials: false}) => {
  // 1 注册 2  登录 3 密码重置 4 修改绑定手机号码 5注销账号 7 解绑设备
  let url = `${head}/user/${version}/sendSMSVerifyCode`
  return await request.post(url, params, options)
}

/**
 * @description: 校验短信验证码
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const checkSMSVerifyCode = async (params = {}, options = {needCredentials: false}) => {
  // 1 注册 2  登录 3 密码重置 4 修改绑定手机号码 5注销账号
  let url = `${head}/user/${version}/checkSMSVerifyCode`
  return await request.post(url, params, options)
}

/**
 * @description: 手机号登录
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const loginByPhone = async (params = {}, options = {needCredentials: false}) => {
  if (params.passType === 2) {
    // 对密码进行加密
    params.pass = Encrypt.encrypt(params.pass)
  }
  let url = `${head}/user/${version}/loginByPhone`
  return await request.post(url, params, options)
}

/**
 * @description: 验证码登录，未注册
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const loginOrRegistByPhone = async (params = {}, options = {needCredentials: false}) => {

  let url = `${head}/user/${version}/loginOrRegistByPhone`
  return await request.post(url, params, options)
}

/**
 * @description: 获取设备列表
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const deviceList = async (data = {}, params = {}, options = {
  needToken: true,
  needPage: true,
  needLimit: true,
  needCredentials: false
}) => {

  let url = `${head}/user/${version}/deviceList`
  return await request.get(url, data, params, options)
}


/**
 * @description: 获取token
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const devAccessToken = async (data, params={}, options={needToken: true, needCredentials: false}) => {
  let url = `${head}/user/${version}/device/devAccessToken`
  return await request.post(url, data, params, options)
}

/**
 * @description: 保存到设备
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const fileDownload = async (data, params = {}, options = {needToken: true, needShareKey:true,needCredentials: false}) => {
  // let accessToken = localStorage.getItem('ak') || params.ak
  let url = store.state.Api_Version=='v1'?`/user/share/${version}/fileDownload`:'/share/api/v2/saveFiles'
  return await request.post(url, data, params, options)
}

/**
 * @description: 获取用户个人信息
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const profile = async (params = {}, options = {
  needToken: true,
  needCredentials: false
}) => {
  let url = `${head}/user/${version}/profile`
  return await request.get(url, {}, params, options)
}


/**
 * @description: 退出登录
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const logout = async (data, params = {}, options = {
  needToken: true,
  needCredentials: false
}) => {

  let url = `${head}/user/${version}/logout`
  return await request.get(url, data, params,options)
}


/**
 * @description: 检查手机号是否注册
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */

export const checkPhoneIsRegisted = async (params = {}, options={needCredentials: false}) => {
  let url = `${head}/user/${version}/checkPhoneIsRegisted`
  return await request.post(url, params, options)
}

/**
 * @description: 获取消费地址
 * @param {*} params 接口数据
 * @param {*} options 请求配置
 * @returns {*}
 */

export const checkConsume = async (params = {}, options = {}) => {
  let url = `/albumh5/api/v1/downloadUrl`
  // return await request.post(url, params)

  const obj = getPdkdSign(url, params)
  options['headers'] = obj.options
  // options.headers['X-API-SIGN'] = obj.options['X-API-SIGN']
  const newUrl = head + url + '?appId=' + obj.appId + '&timestamp=' + obj.timestamp
  return await request.post(newUrl, params, options)
}

export const searchUsers = (param, options) => {
  const url = '/albumh5/api/v1/downloadUrl'
  const obj = getPdkdSign(url, params)
  const params = {
    appId: obj.appId,
    timestamp: obj.timestamp
  }
  return request.post(url, param, options, params, {
    header: obj.options
  })
}

/**
 * @description: 获取分享文件二维码
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */

 export const getQrcode = async (params = {}, options={needCredentials: false}) => {
    let url = `${head}/user/share/${version}/qrcode`
    return await request.get(url,{}, params, options)
  }

/**
 * @description: 获取错误码最新版本和下载地址
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
 export const getVersion = async (data = {},options = { noToast: true }) => {
  const obj = setSign('user/other/v1/latestErrCodeVersion');
  return await request.get('/' + obj.url,data, { 'X-API-SIGN': obj.options['X-API-SIGN'] }, { ...options, headers: { 'X-API-SIGN': obj.options['X-API-SIGN'] } });
};

/**
 * @description: 获取最新版本的错误码信息
 * @param {*} params 接口数据
 * @param {*} options 请求额外配置，预留值
 * @return {*}
 */
export const getErrorCode = async (data = {}, options = { noToast: true }) => {
  const obj = setSign('user/other/v1/latestErrCodeDetail');
  return await request.get('/' + obj.url, data ,{ 'X-API-SIGN': obj.options['X-API-SIGN'] }, { ...options, headers: { 'X-API-SIGN': obj.options['X-API-SIGN'] } });
};



// WEBPACK FOOTER //
// ./src/api/api.js